import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, HttpApiQueryRepository, Query, QueryResult } from '@softline/core';
import { QueryDataSource } from '@softapps/core';
import { SOFTLINE_API_ABC_ANALYSIS_OVERVIEW } from '../abc-analysis.api';
import { AbcAnalysisOverviewMaster } from '../types/abc-analysis-master';
import { AbcAnalysisOverviewRow } from '../types/abc-analysis-overview-row';

@Injectable()
export class AbcAnalysisOverviewGridService
  extends HttpApiQueryRepository<AbcAnalysisOverviewRow, AbcAnalysisOverviewMaster>
  implements QueryDataSource<AbcAnalysisOverviewRow>
{
  type = 'query' as const;

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ABC_ANALYSIS_OVERVIEW);
  }

  protected override getLoadPathParams(params: {
    query: Query<AbcAnalysisOverviewRow>;
    master?: AbcAnalysisOverviewMaster;
  }): Dictionary<unknown> | undefined {
    return {
      baseMeasure: params.master?.baseMeasure,
      abcAnalysisId: params.master?.abcAnalysisId,
    };
  }

  // Forward the built query's columns as-is — an ungrouped caller can still pass columns: []
  // for "all columns" (per the OpenAPI spec), while a grouped/aggregated caller needs its
  // usage/agg column instructions to actually reach the backend.
  protected override getLoadPayload(params: {
    query: Query<AbcAnalysisOverviewRow>;
    master?: AbcAnalysisOverviewMaster;
  }): unknown {
    return params.query;
  }

  override load(params: {
    query: Query<AbcAnalysisOverviewRow>;
    master?: AbcAnalysisOverviewMaster;
  }): Promise<QueryResult<AbcAnalysisOverviewRow> & { lastRow: number }> {
    return super.load(params) as Promise<QueryResult<AbcAnalysisOverviewRow> & { lastRow: number }>;
  }
}
